(function () {
  'use strict';

  angular
      .module('tfc.Reports')
      .filter('reportTitle', reportTitle);

  // @ngInject
  function reportTitle(translateFilter) {
    return function (report) {
      if (report) {
        return _.unescape(translateFilter('reports.title.' + report.key.category, report.key));
      }
    };
  }

})();
